export enum UIErrorComponent {
  Text = 'Text',
  Fullscreen = 'Fullscreen',
  Action = 'Action',
}
